module.exports = __webpack_public_path__ + "img/IL.6b67a19a.svg";